export default "__VITE_ASSET__BIbOb4EY__"